<template>
    <layout-user containerClass="bg-white">
    </layout-user>
</template>
<script>
import mixin from '../../mixin'
import LayoutUser from '../../layouts/User.vue'

export default {
    mixins: [mixin],
    components: {
        'layout-user': LayoutUser,
    },
    data() {
        return {
            pageTitle: 'Logout',
            prevRoute: null,
        }
    },
    beforeCreate() {
    },
    mounted() {
        try{
            this.$auth.logout({
                redirect: '/',
                makeRequest: true,
            })
            .then(() => {
                this.$root.setFlagLoadSettings(true);
                this.$auth.unremember();
                this.deleteAllCookies();
            }).catch(error => {
                console.error('logout:', error);
                this.handleBack();
            });
        } catch(err) {
            console.error(err.message);
        }
    },
    methods: {
        deleteAllCookies() {
            let cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                let eqPos = cookie.indexOf("=");
                let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        },
    }
}
</script>